import './style.scss'; 
 
import React, { FC, useContext, useEffect } from "react";
import EmptyContent from "../EmptyContent";
import Alert from "shared/ui/Alert";
import DocumentIllustration from "../DocumentIllustration";
import Button, { Button_Style, Button_Type } from "shared/ui/Button/Button";
import { useLocation, useNavigate } from "react-router-dom";
import { UserContext } from "features/account";

type UnauthorizedPageProps = {
    message?: string,
    alertText?: string,
    btnText?: string,
    urlBtn?: string,
}

const UnauthorizedPage: FC<UnauthorizedPageProps> = ({
     message = "Accès restreint",
     alertText = "Veuillez contacter l'administrateur pour débloquer l'accès.",
    btnText,
  urlBtn
}) => {
    const location = useLocation();

    const navigate = useNavigate();
    const { user, userType, isVerified, getMe } = useContext(UserContext);


    useEffect(() => {
        getMe()
    }, [location.pathname, user?.email]);

    return (
        <div className="UnauthorizedPage">
            <div className="content__body">
                <div className="FilterOverview h-100">
                    <div className="content__body h-100">
                        <div className="row flex-wrap">
                            <div className="col-sm-4">
                                <div className="content--card relative h-100">
                                    <EmptyContent text={message} showIcon={false} />
                                    <br />
                                    <Alert type="info">
                                        <div className="d-flex flex-column justify-content-center align-items-center gap-1">
                                            {alertText}
                                            {btnText && (
                                              <Button
                                                size={"50px"}
                                                type={Button_Type.PRIMARY}
                                                style={Button_Style.SOLID}
                                                label={btnText}
                                                onClick={()=> {navigate(`${userType === 'partner' ? '/professionnels' : '/particuliers'}/${urlBtn}`);}}
                                                className="ml-2"
                                              />
                                            )}
                                        </div>
                                    </Alert>
                                </div>
                            </div>
                            <div className="col-sm-8">
                                <DocumentIllustration />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


export default UnauthorizedPage;